// Safari does not support ReadableStream async iteration (Symbol.asyncIterator).
// pdfjs-dist v5 uses `for await...of` on ReadableStream internally, which breaks
// in Safari with "TypeError: undefined is not a function".
// This polyfill adds the missing async iterator protocol.

if (typeof ReadableStream !== "undefined" && !ReadableStream.prototype[Symbol.asyncIterator]) {
  ReadableStream.prototype[Symbol.asyncIterator] = async function* () {
    const reader = this.getReader()
    try {
      while (true) {
        const { done, value } = await reader.read()
        if (done) return
        yield value
      }
    } finally {
      reader.releaseLock()
    }
  }
}
